import React from 'react';
import withContentLayout from '../../hoc/withContentLayout';
import ForwardAFriendContainer from '../../containers/ForwardAFriendContainer/ForwardAFriendContainer';

const ForwardAFriendLayout = () => {
  return <ForwardAFriendContainer />;
};

export default ForwardAFriendLayout;
